var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (this.$store.getters.showContent)?_c('div',{staticClass:"container d-flex justify-content-center"},[_c('TableList',{staticClass:"table-sm table-striped div-sm",attrs:{"columns":this.$store.state.columns.referralsStatistics,"items":_vm.referralsStatistics}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }